import React, { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import AudioAdCampaignsReportModal from './AudioAdCampaignsReportModal';
import DefaultAdCampaignsReportModal from './DefaultAdCampaignsReportModal';
import { useRequestAdCampaignsReportViewModel } from './useRequestAdCampaignsReportViewModel';

const RequestAdCampaignsReportModal: FC<ModalProps[ModalTypes.REPORT_CREATE_AD_CAMPAIGNS]> = ({
  refetchReports,
  adcampaignReportType,
  close,
}) => {
  const {
    closeButtonText,
    endDate,
    externalRecipientEmails,
    isAudioAdsReport,
    isExternalRecipientsInputVisible,
    isMobile,
    isPromoDraftLoading,
    isRequestDisabled,
    isReportAddressesLoading,
    loading,
    modalTitle,
    onDateRangeChange,
    onExternalRecipientEmailsChange,
    onModalClose,
    onReportScopeChange,
    onRequestSubmit,
    onRetryPromoDraftCreate,
    onSelectedAddressIdsChange,
    onSelectedRecipientIdsChange,
    onShowExternalRecipientsInput,
    recipients,
    reportAddresses,
    reportAddressTags,
    reportScope,
    promoDraftError,
    promoDraftId,
    promoTotalCount,
    requestButtonText,
    selectedAddressIds,
    selectedPromoCount,
    selectedRecipientIds,
    setSelectedPromoCount,
    startDate,
  } = useRequestAdCampaignsReportViewModel({
    adcampaignReportType,
    close,
    refetchReports,
  });

  if (isAudioAdsReport) {
    return (
      <AudioAdCampaignsReportModal
        close={close}
        closeButtonText={closeButtonText}
        endDate={endDate}
        externalRecipientEmails={externalRecipientEmails}
        isExternalRecipientsInputVisible={isExternalRecipientsInputVisible}
        isMobile={isMobile}
        isPromoDraftLoading={isPromoDraftLoading}
        isRequestDisabled={isRequestDisabled}
        isReportAddressesLoading={isReportAddressesLoading}
        loading={loading}
        modalTitle={modalTitle}
        onDateRangeChange={onDateRangeChange}
        onExternalRecipientEmailsChange={onExternalRecipientEmailsChange}
        onModalClose={onModalClose}
        onReportScopeChange={onReportScopeChange}
        onRequestSubmit={onRequestSubmit}
        onRetryPromoDraftCreate={onRetryPromoDraftCreate}
        onSelectedAddressIdsChange={onSelectedAddressIdsChange}
        onSelectedRecipientIdsChange={onSelectedRecipientIdsChange}
        onShowExternalRecipientsInput={onShowExternalRecipientsInput}
        recipients={recipients}
        reportAddresses={reportAddresses}
        reportAddressTags={reportAddressTags}
        reportScope={reportScope}
        promoDraftError={promoDraftError}
        promoDraftId={promoDraftId}
        promoTotalCount={promoTotalCount}
        requestButtonText={requestButtonText}
        selectedAddressIds={selectedAddressIds}
        selectedPromoCount={selectedPromoCount}
        selectedRecipientIds={selectedRecipientIds}
        setSelectedPromoCount={setSelectedPromoCount}
        startDate={startDate}
      />
    );
  }

  return (
    <DefaultAdCampaignsReportModal
      close={close}
      closeButtonText={closeButtonText}
      endDate={endDate}
      isMobile={isMobile}
      isRequestDisabled={isRequestDisabled}
      loading={loading}
      modalTitle={modalTitle}
      onDateRangeChange={onDateRangeChange}
      onRequestSubmit={onRequestSubmit}
      requestButtonText={requestButtonText}
      startDate={startDate}
    />
  );
};

export default memo(RequestAdCampaignsReportModal);
